import { render, staticRenderFns } from "./PacientePresencialComponente.vue?vue&type=template&id=1679c7d2"
import script from "./PacientePresencialComponente.vue?vue&type=script&lang=js"
export * from "./PacientePresencialComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports